export class UserProfile {
  public name: string;
  public photoURL: string;
  public age: number;
  public savedContributors: string[];
  public country: string;
  public gender: string;
  public interests: string[];
  public locale: string;

  constructor() {
    this.name = "";
    this.photoURL = "";
    this.age = 20;
    this.savedContributors = [];
    this.country = "";
    this.gender = "";
    this.interests = [];
    this.locale = "";
  }
}
